import { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';

import { register } from '../../actions/auth';
import { setAlert } from '../../actions/alert';

const Register = () => {

    const dispatch = useDispatch();

    const { isAuthenticated } = useSelector(state => state.auth);

    const [registerData, setRegisterData] = useState({
        nombre: null,
        apellido_paterno: null,
        apellido_materno: null,
        celular: null,
        email: null,
        password: null
    });

    const [celularDialCode, setCelularDialCode] = useState('52');

    /* Register */
    const onChange = (e) => {
        setRegisterData({
            ...registerData,
            [e.target.name]: e.target.value
        })
    }

    const handleKeyPressRegister = (e) => {
        if(e.keyCode === 13){
            submitRegister();
        }
    }

    const submitRegister = () => {
        if(!registerData.celular){
            dispatch(setAlert('El número de celular es obligatorio', 'danger'));
            return;
        }

        if (registerData.celular && (registerData.celular.length - celularDialCode.length) !== 10) {
            dispatch(setAlert('El teléfono debe tener 10 dígitos sin contar la lada.', 'danger'));
            return;
        }

        if(!registerData.email){
            dispatch(setAlert('El correo electrónico es obligatorio', 'danger'));
            return;
        }

        dispatch(register(registerData));
    }

    /* Funciones generales */
    const onViewPassword = (origen) => {
        let registerInputType = document.getElementById(origen).type;
        
        if(registerInputType == 'password')document.getElementById(origen).type = 'text';
        else document.getElementById(origen).type = 'password';
    }

    useEffect(() => {
        if(isAuthenticated){
            window.location.href = '/dashboard';
        }
    }, [isAuthenticated]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        body{
                            background-color: #091121;
                        }
                        
                        .centradoVertical {
                            margin: 0;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                        
                        .btnIniciar {
                            background: #0CB394;
                            border-color: #0CB394;
                        }
                        
                        .bgImg {
                            height: 100%;
                            opacity: 0.2;
                            position: absolute;
                        }
                        
                        .logoHeader {
                            height: 7vw;
                            min-height: 120px;
                            max-height: 150px;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <div className="row">
                <div className="col-md-6 offset-md-3 centradoVertical">
                    <div className="card bg-light"> 
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12 text-center mb-3">
                                    <img src={process.env.REACT_APP_PUBLIC_ROUTE + '/assets/images/logo/imagotipo-color.png'} className="d-inline-block logoHeader" alt="logo"/>
                                    <h5 className="card-title">Crear cuenta</h5>
                                </div>

                                <div className="col-md-12 mb-3">
                                    <div className="alert alert-info d-flex align-items-start gap-2 mb-0 py-2" role="alert" style={{ fontSize: '0.875rem' }}>
                                        <i className="fa-solid fa-circle-info mt-1 flex-shrink-0"></i>
                                        <span>
                                            Regístrate con tus <strong>datos personales</strong>. Una vez dentro podrás completar los datos de tu empresa desde la sección de configuración.
                                        </span>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="input-group mb-3">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={registerData.nombre || ''} onChange={e => onChange(e)} onKeyDown={handleKeyPressRegister}></input>
                                            <label htmlFor="nombre">Nombre</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="input-group mb-3">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" placeholder="Apellido paterno" id="apellido_paterno" name="apellido_paterno" value={registerData.apellido_paterno || ''} onChange={e => onChange(e)} onKeyDown={handleKeyPressRegister}></input>
                                            <label htmlFor="apellido_paterno">Apellido paterno</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="input-group mb-3">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" placeholder="Apellido materno" id="apellido_materno" name="apellido_materno" value={registerData.apellido_materno || ''} onChange={e => onChange(e)} onKeyDown={handleKeyPressRegister}></input>
                                            <label htmlFor="apellido_materno">Apellido materno</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="mb-3">
                                        <PhoneInput
                                            country="mx"
                                            preferredCountries={['mx', 'us']}
                                            enableSearch={true}
                                            placeholder="Celular *"
                                            value={registerData.celular || ''}
                                            onChange={(value, countryData) => {
                                                setRegisterData({ ...registerData, celular: value });
                                                setCelularDialCode(countryData.dialCode);
                                            }}
                                            inputClass="form-control"
                                            containerClass="w-100"
                                            inputStyle={{ width: '100%', height: 'calc(3.5rem + 2px)' }}
                                            buttonStyle={{ height: 'calc(3.5rem + 2px)' }}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="input-group mb-3">
                                        <div className="form-floating">
                                            <input type="email" className="form-control" placeholder="Correo" id="email" name="email" value={registerData.email || ''} onChange={e => onChange(e)} onKeyDown={handleKeyPressRegister}></input>
                                            <label htmlFor="email">Correo</label>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-md-4">
                                    <div className="input-group mb-3">
                                        <div className="form-floating">
                                            <input type="password" id="password" className="form-control" placeholder="Contraseña" name="password" value={registerData.password || ''} onChange={e => onChange(e)} onKeyDown={handleKeyPressRegister}></input>
                                            <label htmlFor="password">Contraseña</label>
                                        </div>
                                        <div className="input-group-append">
                                            <button className="btn btn-primary viewPassword" onClick={() => onViewPassword('password')}><i className="fa-solid fa-eye"></i></button>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group mt-3 text-center">
                                        <button type="button" className="btn btn-primary w-100" onClick={() => submitRegister()}>Crear cuenta</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Register;